import { render, staticRenderFns } from "./ReuploadOrderDocuments.vue?vue&type=template&id=3c021a5f&scoped=true&"
import script from "./ReuploadOrderDocuments.vue?vue&type=script&lang=js&"
export * from "./ReuploadOrderDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ReuploadOrderDocuments.vue?vue&type=style&index=0&id=3c021a5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c021a5f",
  null
  
)

export default component.exports